import { Link } from 'react-router-dom'
import { BlindnessBoard } from '@/routes/fleet/BlindnessBoard'
import { StatusChip } from '@/components/ui/status-chip'
import type { WidgetSpan } from '../Widget'
import { Widget } from '../Widget'

export function BlindnessBoardWidget({ span = 12 }: { span?: WidgetSpan }) {
  return (
    <Widget
      title="Data-blindness board"
      badges={
        <>
          <StatusChip status="warn">worst-first</StatusChip>
          <StatusChip status="info">FR-CAT-05</StatusChip>
        </>
      }
      span={span}
      bodyPadding={false}
      footer={
        <Link to="/fleet#blindness" className="font-semibold text-accent hover:underline">
          Open full data-blindness board →
        </Link>
      }
    >
      <BlindnessBoard limit={6} />
    </Widget>
  )
}
